export function getRequestLabel(requestStatusType) {
  if (requestStatusType) {
    return 'Newsboard.YourRequestLabelKey'
  }

  return 'Newsboard.AttachedRequestLabelKey'
}

export function getRequestAddress(request) {
  return request.building.title
}
